@if (description) {
  <span class="wb-summary-name">
    {{description | ucFirst}}
    @if (config.helpText) {
      <span class="wb-help"
        (click)="toggleHelpModal(config.label, config.helpText)"><app-svg-icon [icon]="faInfoCircle"></app-svg-icon>
      </span>
    }
  </span>
}
<div [formGroup]="control">
  <div class="subtract" (click)="mutate(false)"><app-svg-icon [icon]="faMinus"></app-svg-icon></div>
  <input type="number" id="{{config.property}}" [min]="min" [max]="max" [formControlName]="config.property" />
  <div class="add" (click)="mutate()"><app-svg-icon [icon]="faPlus"></app-svg-icon></div>
</div>
